<template>
  <v-card class="grey lighten-5 rounded-0">
    <v-skeleton-loader class="grey lighten-4 pa-6" type="sentences" />
    <v-divider />
    <div class="breakdown-grid px-6 py-3">
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" width="200" />
      <v-skeleton-loader type="text" width="200" />
    </div>
    <div class="breakdown-grid px-6 py-3">
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
    </div>
    <div class="breakdown-grid px-6 py-3">
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
    </div>
    <div class="breakdown-grid px-6 py-3">
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
    </div>
    <div class="breakdown-grid px-6 py-3">
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
    </div>
    <div class="breakdown-grid px-6 py-3">
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
    </div>
    <div class="breakdown-grid px-6 py-3">
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
    </div>
    <div class="duplicate-controls pa-6">
      <v-skeleton-loader class="flex-grow-1" type="text" />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DuplicateGroupSkeletonLoader',
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.breakdown-grid {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr;
  gap: 16px;
}
.duplicate-controls {
  background: map-get($grey, 'lighten-4');
  border-top: 1px solid map-get($grey, 'lighten-2');
}
</style>
